export default "__VITE_ASSET__Ui7c8O3b__"